
export default {
  i18nComponentKey: 'ReviewsNew.components.AiInfo',
  name: 'AiInfo',
  props: {
    description: { type: String, required: true }
  }
};
